import React from 'react';
import { Popconfirm } from 'antd';
import {
  createColumnText,
  createColumnButtonArr,
  widthOptions,
} from '../../../components/table/function/createColumn';
import { ButtonTheme, ButtonToolTip } from '../../../components';

const TEXT_PREVIEW_LENGTH = 120;

export const columns = ({ onEdit, onDelete }) => [
  createColumnText('ชื่อ template', 'templateName', widthOptions(220)),
  createColumnText(
    'ข้อความ',
    'templateText',
    widthOptions(360, {
      render: (text) => (
        <div style={{ whiteSpace: 'pre-wrap' }}>
          {text?.length > TEXT_PREVIEW_LENGTH ? `${text.slice(0, TEXT_PREVIEW_LENGTH)}…` : text}
        </div>
      ),
    }),
  ),
  createColumnText(
    'แก้ไขล่าสุด',
    'updatedAt',
    widthOptions(200, {
      render: (_, record) => (
        <div>
          <div>{record.updatedAt || '-'}</div>
          <div style={{ fontSize: 12, color: '#999' }}>{record.updatedBy || '-'}</div>
        </div>
      ),
    }),
  ),
  createColumnButtonArr('จัดการ', 'templateId', {
    others: {
      fixed: 'right',
      width: 160,
    },
    buttonArr: [
      {
        useFor: 'EDIT3',
        render: (text, record) => (
          <ButtonToolTip toolTip="แก้ไข" placement="topLeft">
            <ButtonTheme useFor="EDIT3" onClick={() => onEdit(record)} />
          </ButtonToolTip>
        ),
      },
      {
        useFor: 'DELETE2',
        render: (text, record) => (
          <ButtonToolTip toolTip="ลบ" placement="topLeft">
            <Popconfirm
              title="คุณต้องการที่จะลบ template นี้ใช่หรือไม่?"
              onConfirm={() => onDelete(record)}
              okText="ใช่"
              cancelText="ไม่"
            >
              <ButtonTheme useFor="DELETE2" />
            </Popconfirm>
          </ButtonToolTip>
        ),
      },
    ],
  }),
];
